import * as types from './types';
import { loading } from 'State/actions';

export const getCaseTypeReport = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CASE_TYPE_REPORT_FETCHING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Reports/CaseType',
        data
      );
      dispatch({
        type: types.CASE_TYPE_REPORT_GET_REPORT,
        payload: response.data.Data ? response.data.Data : 'No Data',
      });
    } catch (error) {
      dispatch({
        type: types.CASE_TYPE_REPORT_FETCH_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.CASE_TYPE_REPORT_FETCHING, false));
  };
};

export const clearReport = () => {
  return {
    type: types.CASE_TYPE_REPORT_GET_REPORT,
    payload: null,
  };
};

export const getGradesAction = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CASE_TYPE_REPORT_FETCHING, true));

    try {
      const response = await MPWWebApi.getGeneric('grade');
      dispatch({
        type: types.CASE_TYPE_REPORT_GET_GRADES,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: types.CASE_TYPE_REPORT_FETCH_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.CASE_TYPE_REPORT_FETCHING, false));
  };
};

export const getCaseTypesAction = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CASE_TYPE_REPORT_FETCHING, true));

    try {
      const response = await MPWWebApi.getGeneric('StuCaseType/Categories');
      dispatch({
        type: types.CASE_TYPE_REPORT_GET_CASE_TYPES,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: types.CASE_TYPE_REPORT_FETCH_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.CASE_TYPE_REPORT_FETCHING, false));
  };
};



// WEBPACK FOOTER //
// ./src/pages/casetype/state/casetypereport/actions.js